export default __webpack_public_path__ + "static/media/user-profile.6ced3b5a.jpg";